const entities = {
    TOPICS: 'topics',
    LOGOS: 'logos',
};

export default entities;
